export { default } from './EditQuestionAnswerBlock';

export const displayName = 'Q&A';
